import React from 'react';
import styled from '@benzinga/themetron';
import { runningClientSide } from '@benzinga/utils';

export interface WidgetProps {
  attrs: any;
}

export const WistiaPlayer: React.FC<WidgetProps> = ({ attrs }) => {
  if (!attrs.data?.videoid) {
    return null;
  }

  if (runningClientSide()) {
    const script = document.querySelector('#wistia-script');
    if (script) {
      script.remove();
    }

    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    scriptElement.setAttribute('async', 'true');
    scriptElement.setAttribute('id', 'wistia-script');

    scriptElement.onerror = (event: string | Event) => {
      if (typeof event === 'object' && event.type === 'error') {
        console.error('Failed to load wistia');
      }
    };

    document.body.appendChild(scriptElement);
  }

  return (
    <WidgetWrapper>
      <div className={`wistia_embed wistia_async_${attrs.data?.videoid} autoPlay=true videoFoam=true`}>&nbsp;</div>
    </WidgetWrapper>
  );
};

export const WidgetWrapper = styled.div`
  margin: 16px 0;
  .wistia_embed {
    width: 100%;
    height: 100%;
  }
`;
